
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ModalContent from "@/components/modal/ModalContent.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";

import FormWrapper from "@/components/form/FormWrapper.vue";
import FormGroup from "@/components/form/FormGroupCustom.vue";
import UIButton from "@/components/button/ui-button.vue";
import CrossIconHover from "@/components/icons/CrossIconHover.vue";
import DeleteGray from "@/components/icons/DeleteGray.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import CrossIcon from "@/components/icons/CrossIconNew.vue";

@Component({
  components: {
    ModalContent,
    ModalFullScreen,
    CrossIconHover,
    FormWrapper,
    FormGroup,
    UIButton,
    CrossIcon,
    DeleteGray,
  },
})
export default class ManagementAddContractorInfo extends Vue {
@Prop({ type: String, required: false })
readonly website?: String;
@Prop({ type: String})
readonly name?: String;


isHovered: boolean  = false;
updatedWebsite: string = this.website ? this.website.toString() : '';

  closeModal(): void {
    this.$emit("close");
  }

addWebsite() {
   
      if (this.updatedWebsite.length > 0) {
        this.$emit('edit-website', { oldName: this.website, newName: this.updatedWebsite });
      } else {
        this.$emit('add-website', this.website);
      }
      this.$emit('close');
    }

    editWebsite() {
        this.$emit('edit-website', {
        oldName: this.updatedWebsite,
        newName: this.website
      });
      this.closeModal();
    }

}
